module.exports = __webpack_public_path__ + "media/landing_page/twitter-cashew-7bc096be.svg";